import { AlertTypesID } from "@shared/constants/alert-types.enum";
import { VehicleTypesID } from "@shared/constants/vehicle-types.enum";
import { AlertTypeMessages, DualListboxMessages, FilterMessages, ManagementMessages } from "@shared/languages/interfaces";
import { User } from "@shared/interfaces/user.interface";
import { TpeAlertWithFunctionality, UserFunctionalityID } from "./types";

export const getSecurityAlerts = (t: (key: string) => string) => {
  const ALLOWED_CHANGE_PARAMS: TpeAlertWithFunctionality = {
    description: t(ManagementMessages.allowedChangeParams),
    isAFunctionality: true,
    idFunctionality: UserFunctionalityID.ALLOWED_CHANGE_PARAMS
  };
  const ALLOWED_CHANGE_VEHICLES: TpeAlertWithFunctionality = {
    description: t(ManagementMessages.allowedChangeVehicles),
    isAFunctionality: true,
    idFunctionality: UserFunctionalityID.ALLOWED_CHANGE_VEHICLES
  };
  const ALLOWED_CHANGE_DRIVERS: TpeAlertWithFunctionality = {
    description: t(ManagementMessages.allowedChangeDrivers),
    isAFunctionality: true,
    idFunctionality: UserFunctionalityID.ALLOWED_CHANGE_DRIVERS
  };
  const ALLOWED_CHANGE_LOCATIONS: TpeAlertWithFunctionality = {
    description: t(ManagementMessages.allowedChangeLocations),
    isAFunctionality: true,
    idFunctionality: UserFunctionalityID.ALLOWED_CHANGE_LOCATIONS
  };
  const ALLOWED_BLOCK_VEHICLE: TpeAlertWithFunctionality = {
    id_alert_type: AlertTypesID.BLOQUEIO,
    description: t(AlertTypeMessages[AlertTypesID.BLOQUEIO]),
    isAFunctionality: true,
    idFunctionality: UserFunctionalityID.ALLOWED_BLOCK_VEHICLE
  };

  return {
    ALLOWED_CHANGE_PARAMS,
    ALLOWED_CHANGE_VEHICLES,
    ALLOWED_CHANGE_DRIVERS,
    ALLOWED_CHANGE_LOCATIONS,
    ALLOWED_BLOCK_VEHICLE
  };
};

export const getDualListboxLang = (t: (key: string) => string) => ({
  availableFilterHeader: t(DualListboxMessages.availableFilterHeader),
  availableHeader: t(DualListboxMessages.permittedVehiclesHeader),
  moveAllLeft: t(DualListboxMessages.moveAllLeft),
  moveAllRight: t(DualListboxMessages.moveAllRight),
  moveLeft: t(DualListboxMessages.moveLeft),
  moveRight: t(DualListboxMessages.moveRight),
  moveBottom: t(DualListboxMessages.moveBottom),
  moveDown: t(DualListboxMessages.moveDown),
  moveUp: t(DualListboxMessages.moveUp),
  moveTop: t(DualListboxMessages.moveTop),
  noAvailableOptions: t(DualListboxMessages.noAvailableOptions),
  noSelectedOptions: t(DualListboxMessages.noSelectedOptions),
  selectedFilterHeader: t(DualListboxMessages.selectedFilterHeader),
  selectedHeader: t(DualListboxMessages.restrictedVehiclesHeader)
});

export const getFormattedRestrictVehicleOptions = (t: (key: string) => string, vehicleOptions: any[]) => {
  const mappedOptions = vehicleOptions.map((vehicle) => ({
    label: `${vehicle.code} - ${vehicle.license_plate}`,
    value: vehicle.id_vehicle,
    type: vehicle.type
  }));

  return [
    {
      label: t(FilterMessages.concreteMixers),
      options: mappedOptions.filter(
        (vehicle) => vehicle?.type?.id_vehicle_type === VehicleTypesID.BETONEIRA
      )
    },
    {
      label: t(FilterMessages.pumpTrucks),
      options: mappedOptions.filter(
        (vehicle) => vehicle?.type?.id_vehicle_type === VehicleTypesID.CAMINHAO_BOMBA
      )
    },
    {
      label: t(FilterMessages.supportVehicles),
      options: mappedOptions.filter(
        (vehicle) => vehicle?.type?.id_vehicle_type === VehicleTypesID.VEICULO_DE_APOIO
      )
    },
    {
      label: t(FilterMessages.loaders),
      options: mappedOptions.filter(
        (vehicle) => vehicle?.type?.id_vehicle_type === VehicleTypesID.PA_CARREGADEIRA
      )
    },
    {
      label: t(FilterMessages.siloTrucks),
      options: mappedOptions.filter(
        (vehicle) => vehicle?.type?.id_vehicle_type === VehicleTypesID.CARRETA_SILO
      )
    },
    {
      label: t(FilterMessages.aggregateTrucks),
      options: mappedOptions.filter(
        (vehicle) => vehicle?.type?.id_vehicle_type === VehicleTypesID.CARRETA_AGREGADOS
      )
    }
  ];
};

/**
 * Profile shown in the users list: super admin, admin or regular user (an inactive admin is still an admin)
 * @param t Translation function
 * @param user User of the row
 * @returns The translated profile name
 */
export const getUserProfileLabel = (t: (key: string) => string, user: Pick<User, "admin" | "super_admin">): string => {
  if (user?.super_admin) return t(ManagementMessages.profileSuperAdmin);
  if (user?.admin) return t(ManagementMessages.profileAdmin);

  return t(ManagementMessages.profileUser);
};

export const dataTableSettings: DataTables.Settings = {
  order: [[0, "asc"]],
  columnDefs: [{ className: "dt-center", targets: -1 }]
};
